import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHero({ overline, title, subtitle, crumb, image }) {
  return (
    <section
      className="relative overflow-hidden text-white"
      style={{ background: "radial-gradient(120% 120% at 85% 0%, #16347A, #0A1E4E 55%, #071538)" }}
      data-testid="page-hero"
    >
      <div className="absolute inset-0 paper-grain opacity-40" />
      {image && (
        <div className="absolute right-0 top-0 hidden md:block h-full w-1/3 opacity-[0.12]"
          style={{ backgroundImage: `url(${image})`, backgroundSize: "cover", backgroundPosition: "center", filter: "blur(3px)",
            clipPath: "polygon(25% 0, 100% 0, 100% 100%, 0% 100%)" }} />
      )}
      <div className="container-x relative py-16 sm:py-20 lg:py-24">
        <div className="flex items-center gap-1.5 text-xs text-blue-100/60">
          <Link to="/" className="hover:text-[#D4AF37]">Home</Link>
          <ChevronRight size={13} />
          <span className="text-[#D4AF37]">{crumb || title}</span>
        </div>
        {overline && <span className="mt-6 block overline text-[#D4AF37]">{overline}</span>}
        <motion.h1
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-5 max-w-2xl text-lg text-blue-100/85 leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
      <div className="h-1 w-full" style={{ background: "linear-gradient(90deg,#D4AF37,#F5B301,#D4AF37)" }} />
    </section>
  );
}
